import { z } from 'zod';

export const roundSaveSchema = z.object({
  criteriaId: z.number().int().positive(),
  points: z.number().int().min(0).max(3),
  round: z.number().int().min(1).max(10),
  teamName: z.enum(['team1', 'team2', 'team3', 'team4']),
  session: z.string().length(4).optional(),
});

export type RoundSaveInput = z.infer<typeof roundSaveSchema>;
